
export default function CTASection() {
  return (
    <section id="contacto" className="relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        <div className="relative bg-[#f5f1ed] flex items-center justify-center p-8 lg:p-12">
          <div className="relative w-full h-full min-h-[400px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/b73b5b2c5a9c7c8ea52acc3227c7c9c7.jpg"
              alt="Instalaciones Desguace Barcelona"
              className="w-full h-full object-cover rounded-2xl"
            />
            <div className="absolute bottom-8 left-8">
              <span className="inline-block bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold text-[#1a2332] mb-3">
                Desguace Oficial
              </span>
              <h3 className="text-4xl lg:text-5xl font-black text-[#1a2332] leading-tight">
                Líder en<br />
                Compra de Vehículos<br />
                Barcelona
              </h3>
            </div>
          </div>
        </div>

        <div className="bg-white flex items-center justify-center p-8 lg:p-16">
          <div className="max-w-md text-center">
            <h2 className="text-4xl lg:text-5xl font-black text-[#1a2332] mb-6 leading-tight">
              ¿Listo Para Vender<br />Tu Coche Hoy?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              Más de 15.000 clientes han confiado en nosotros. Obtén la mejor tasación del mercado en menos de 24 horas. Sin compromiso, sin complicaciones.
            </p>
            <a 
              href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20tasar%20mi%20coche%20gratis" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-10 py-5 bg-[#1a2332] text-white rounded-full font-bold text-lg hover:bg-[#2d3e50] transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Solicitar Tasación
              <i className="ri-arrow-right-line ml-3 text-xl"></i>
            </a>
            <p className="text-sm text-gray-500 mt-6">
              <i className="ri-shield-check-line text-[#ff6b35] mr-1"></i>
              Proceso 100% legal y seguro
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
